module.exports = __webpack_public_path__ + "static/banner-update-data-bo-MB-2638d73a53f36038d64a0c0dd51edfe6.png";